/** Case-insensitive substring match for layer search */
export const matchSearch = (label: string, searchTerm: string): boolean =>
  label.toLowerCase().includes(searchTerm.toLowerCase());
